import { navigate, Redirect, RouteComponentProps } from "@reach/router";
import React from "react";
import { useQuery } from "@apollo/client";
import { getViewer } from "types/gql-types";
import { LoadingSpinner } from "components/graphql-views";
import Settings from "settings";
import { userLoginToken } from "utils/general-utils";
import { VIEWER_QUERY } from "components/auth/query";

const getRequestedPath = (path:string):string => {

  /* Get the requestedPath from localStorage which is set in
  ui/src/components/auth/authorize-for-role.tsx and remove it from localStorage
  to prevent navigating to it in the future. */
  const requestedPath = localStorage.getItem("requestedPath");
  localStorage.removeItem("requestedPath");

  // Return the param path if requested path is not set
  if (!requestedPath) {
    return path;
  }

  return requestedPath;
};

const Home: React.FC<RouteComponentProps> = () => {
  if (typeof userLoginToken() === "string") {
    const { loading, error, data } = useQuery<getViewer>(VIEWER_QUERY, { fetchPolicy: "cache-and-network" });

    if (loading) return <LoadingSpinner />;

    if (error || !data || data.viewer === null) return <div>Error loading user</div>;

    if (data.viewer.isAdmin) {
      navigate(getRequestedPath("/dash/admin"));
    } else if (data.viewer.isClient) {
      navigate(getRequestedPath("/dash/client/submissions"));
    } else if (data.viewer.isSupervisor || data.viewer.isPropManager) {
      navigate(getRequestedPath("/dash/manager/lists"));
    }
    return null;
  }

  if (Settings.env === "production") {
    navigate("https://www.havenconnect.com");
    return null;
  }

  return <Redirect to="/login" noThrow />;
};

export default Home;
